import { render, staticRenderFns } from "./RetentionTouchpointReminderModal.vue?vue&type=template&id=06df0631&"
import script from "./RetentionTouchpointReminderModal.vue?vue&type=script&lang=js&"
export * from "./RetentionTouchpointReminderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports